import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const FIELD_LABELS = {
  event_name: "Event Name",
  date: "Date",
  end_date: "End Date",
  start_time: "Start Time",
  venue: "Venue",
  city: "City",
};

export function FlyerExtractDialog({ open, extracted, onCancel, onApply, applying }) {
  if (!extracted) return null;
  const fields = Object.keys(FIELD_LABELS).filter((f) => f !== "end_date" || extracted.end_date);
  const anyDetected = fields.some((f) => extracted[f]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && !applying && onCancel()}>
      <DialogContent className="bg-[#121824] border-white/10 text-white" data-testid="flyer-extract-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">
            <i className="fa-solid fa-wand-magic-sparkles mr-2 text-indigo-400" />We detected this from your flyer
          </DialogTitle>
          <DialogDescription>
            {anyDetected
              ? "Review what our AI read off your flyer, then apply it to fill in your event details."
              : "We couldn't clearly read any event details off this flyer. Try a sharper image or fill in the details manually."}
          </DialogDescription>
        </DialogHeader>
        {anyDetected && (
          <ul className="space-y-1.5 max-h-56 overflow-y-auto">
            {fields.map((field) => (
              <li
                key={field}
                className="text-sm bg-white/5 rounded-lg px-3 py-2 flex items-center justify-between gap-3"
                data-testid={`flyer-extract-field-${field}`}
              >
                <span className="text-slate-400">{FIELD_LABELS[field]}</span>
                <span className={extracted[field] ? "text-white font-medium" : "text-slate-500 italic"}>
                  {extracted[field] || "Not detected"}
                </span>
              </li>
            ))}
          </ul>
        )}
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onCancel} className="border-white/15 hover:bg-white/10" data-testid="flyer-extract-cancel-button">
            Cancel
          </Button>
          {anyDetected && (
            <Button
              onClick={onApply}
              disabled={applying}
              className="bg-indigo-500 hover:bg-indigo-600 font-bold"
              data-testid="flyer-extract-apply-button"
            >
              {applying ? "Applying..." : "Apply & Save"}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
